<div class="epd-header">
  <span class="epd-title">Event Payload</span>
</div>

<mat-dialog-content class="epd-content">
  <ng-container *ngIf="formatted; else noPayload">
    <pre class="epd-body">{{ formatted }}</pre>
  </ng-container>
  <ng-template #noPayload>
    <p class="epd-no-payload">This event has no payload.</p>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions class="epd-actions">
  <button mat-stroked-button *ngIf="formatted" (click)="copy()">
    {{ copied ? 'Copied!' : 'Copy to Clipboard' }}
  </button>
  <button mat-flat-button color="primary" (click)="close()">Close</button>
</mat-dialog-actions>
